<template>
  <nav class="navbar is-success is-fixed-top" role="navigation" aria-label="main navigation">
    <div class="navbar-brand">
      <router-link to="/" class="navbar-item">
        <img src="@/assets/logo.png" alt="IceTiger" width="32" height="32">
      </router-link>
      <div class="navbar-burger" @click="showNav = !showNav" :class="{ 'is-active': showNav }">
        <span></span>
        <span></span>
        <span></span>
      </div>
    </div>
    <div class="navbar-menu" id="navMenu" :class="{ 'is-active': showNav }">
      <div class="navbar-start" @click="showNav=false" >

        <!-- IceTiger HOME -->
        <router-link to="/" class="navbar-item has-text-gray" hreflang="en">
          <i class="fas fa-home fa-fw"></i>&nbsp;Home
        </router-link>

        <!-- Social Media -->
        <div class="navbar-item has-dropdown is-hoverable">
          <span class="navbar-link has-text-gray default-pointer">
            <i class="fas fa-signal fa-fw"></i>&nbsp;Social Media
          </span>
          <div class="navbar-dropdown">
            <a class="navbar-item has-text-gray" href="https://twitter.icetiger.eu" hreflang="en">
              <i class="fab fa-twitter fa-fw"></i>&nbsp;Twitter
            </a>
            <a class="navbar-item has-text-gray" href="https://telegram.icetiger.eu" hreflang="en">
              <i class="fab fa-telegram-plane fa-fw"></i>&nbsp;Telegram
            </a>
            <a class="navbar-item has-text-grey" href="https://bsky.app/profile/icetiger.eu" hreflang="en">
              <i class="fas fa-cloud" style="color: #3a87fe;"></i>BlueSky
            </a>
            <a class="navbar-item has-text-gray" href="https://blog.icetiger.eu" hreflang="de">
              <i class="fas fa-rss-square"></i>&nbsp;Blog
            </a>
            <a class="navbar-item has-text-gray" href="https://furbase.icetiger.eu" hreflang="en">
              <i class="fas fa-paw fa-fw"></i>&nbsp;Furbase
            </a>
            <a class="navbar-item has-text-gray" href="mailto:contact@icetiger.eu" hreflang="en">
              <i class="fas fa-envelope"></i>&nbsp;contact at icetiger.eu
            </a>
          </div>
        </div>

        <!-- Events -->
        <div class="navbar-item has-dropdown is-hoverable">
          <span class="navbar-link has-text-gray default-pointer">
            <i class="fas fa-calendar-plus fa-fw"></i>&nbsp;Events
          </span>
          <div class="navbar-dropdown">
            <a class="navbar-item has-text-gray" href="https://nordicfuzzcon.org/" hreflang="en">
              NFC 2024
            </a>
            <hr class="navbar-divider">
            <router-link class="navbar-item has-text-gray" to="/event/past" hreflang="en">
              Past Events
            </router-link>
          </div>
        </div>

        <!-- About IceTiger -->
        <div class="navbar-item has-dropdown is-hoverable">
          <span class="navbar-link has-text-gray default-pointer">
            <i class="fas fa-paw fa-fw"></i>&nbsp;About
          </span>
          <div class="navbar-dropdown">
            <router-link to="/character" class="navbar-item has-text-gray" hreflang="en">
              <i class="far fa-id-badge fa-fw"></i>&nbsp;Character
            </router-link>
            <router-link to="/art" class="navbar-item has-text-gray" hreflang="en">
              <i class="far fa-image fa-fw"></i>&nbsp;Art
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  data: function() {
    return {
      showNav: false
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/navbar.vue